export class Secretary {
    id: number;
    name: string;

    stripeConnectedAccountId: string;

    enablePaymentPlans: boolean;
    numOfInstallments: number;
    initialDeposit: number;

    usePaypal: boolean;
    useStripe: boolean;
    test: boolean;

    constructor() {
        this.numOfInstallments = 3;
        this.initialDeposit = 50;
    }
}


// WEBPACK FOOTER //
// ./src/model/secretary.ts